<template>
<div>
    <app-layout >
        <template #header>
            <h2 class="h4 font-weight-bold">
                Setting
            </h2>
        </template>
                <div v-if="$page.props.flash.message">
                                <div class="alert alert-success" >
                                {{ $page.props.flash.message }}
                                </div>
                        </div>
                <div>
                        <div v-for="(rows,section) in config" :key="section.index" class="mb-4 shadow-sm">
                            <h5 class="bg-dark text-white p-3">{{section}}</h5>
                            <div class="p-4">
                                <div v-for="(row, index) in rows" :key="index" class="row">
                                    <div v-if="row.type=='string'" class="form-group col-sm-6">
                                        <jet-label v-bind:for="row.remark" v-bind:value="row.remark" />
                                        <jet-input type="text" v-model="config[section][index].value"  />
                                    </div>

                                    <div v-if="row.type=='longtext'" class="form-group col-sm-6">
                                        <jet-label v-bind:for="row.remark" v-bind:value="row.remark" />
                                        <textarea class="form-control" v-model="config[section][index].value">
                                        </textarea>
                                    </div>

                                    <div v-if="row.type=='editor'" class="form-group col-12">
                                        <jet-label v-bind:for="row.remark" v-bind:value="row.remark" />
                                        <ckeditor :editor="editor" v-model="config[section][index].value" :config="editorConfig"></ckeditor>
                                    </div>

                                    <div v-if="row.type=='image'" class="form-group col-sm-6">
                                        <input type="file" hidden
                                            :ref="'photo'+row.id"
                                                @change="updatePhotoPreview(row.id)">
                                                
                                        <jet-label v-bind:for="row.remark" v-bind:value="row.remark" />
                                        <!-- Current Profile Photo -->
                                            <div class="row">
                                                <div class="col-sm-6">
                                                    <img :src="row.image_url" alt="Current Image" class="img-fluid img-thumbnail" style="width:200px;height:200px;object-fit:contain;">

                                                    <jet-secondary-button class="mt-2 mr-2" type="button" @click.prevent="selectNewPhoto(row.id)">
                                                     Select A New Photo
                                                    </jet-secondary-button>
                                                </div>

                                            <!-- New Profile Photo Preview -->
                                             <div class="col-sm-6" :ref="'photoPreview'+row.id" style="display:none;">
                                                 <img  class="img-fluid img-thumbnail" :ref="'photoPreviewImg'+row.id" style="width:200px;height:200px;object-fit:contain;">

                                                <jet-secondary-button class="mt-2 mr-2" :id="'uploadbtn'+row.id" style="display:none;" type="button"  @click.prevent="UploadImage(row.id)">
                                                Upload Now
                                                </jet-secondary-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                         </div>
                           <div v-if="$page.props.flash.message">
                                <div class="alert alert-success" >
                                {{ $page.props.flash.message }}
                                </div>
                        </div>
                         <button class="btn btn-success" @click="update(config)">Save</button>
                </div>

    </app-layout>
    </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetActionMessage from '@/Jetstream/ActionMessage'
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  components: {
    AppLayout,
    JetInput,
    JetLabel,
    JetSecondaryButton,
    JetActionMessage,
    ckeditor: CKEditor.component
  },

  props: ['config','errors'],
  data() {
            return {
                photoPreview: null,
                editor: ClassicEditor,
                 editorConfig: {
                    // The configuration of the editor.
                }
            }
        },
        methods: {
            update: function (data) {
                this.$inertia.put('/admin/setting/action/',data,{
                     preserveScroll:true,
                     onSuccess: page => {

                     },
                })
            },

            selectNewPhoto(id) {
            this.$refs["photo"+id].click();
            },

            updatePhotoPreview(id) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.$refs["photoPreview"+id].style.display = "block";
                $("#uploadbtn"+id).show();
                this.$refs["photoPreviewImg"+id].src = e.target.result;
            };

            reader.readAsDataURL(this.$refs["photo"+id].files[0]);
            },

            UploadImage(id){
                 this.$inertia.post("/admin/setting/uploadimg", {
                    _method: 'put',
                    img:  this.$refs["photo"+id].files[0],
                    id: id
                },{
                    onSuccess: page => {
                        this.$refs["photoPreview"+id].style.display = "none";
                        $("#uploadbtn"+id).hide();
                    },
                }
                )
            }

        }

}
</script>
